import PropTypes from 'prop-types';
import { useParams } from 'react-router-dom';

import { ErrorBoundary } from '@zenbusiness/application-commons-logging';
import PageError from '@zenbusiness/zui/PageError';

import { ProductLandingProvider } from './contexts/useProductLanding';
import ProductLanding from './ProductLanding';

const ProductLandingWrapper = ({ federated }) => {
  const { productId } = useParams();

  return (
    <ErrorBoundary fallback={<PageError />} id="src/ProductLanding/ProductLandingWrapper">
      <ProductLandingProvider federated={federated} productId={productId}>
        <ProductLanding />
      </ProductLandingProvider>
    </ErrorBoundary>
  );
};

ProductLandingWrapper.propTypes = {
  federated: PropTypes.bool
};

export default ProductLandingWrapper;
